// ======================================================
// 🔥 PAGE TRACKER ENGINE
// ======================================================

const STORAGE_KEY = "nkVisitedPages";

// ======================================================
// TRACK PAGE VISIT
// ======================================================

export function trackPageVisit(pageName) {

  if (!pageName) return;

  const existing =
    JSON.parse(
      localStorage.getItem(STORAGE_KEY)
    ) || [];

  // Avoid duplicate consecutive visits
  if (existing[existing.length - 1] === pageName) {
    return;
  }

  existing.push(pageName);

  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify(existing)
  );
}

// ======================================================
// GET VISITED PAGES
// ======================================================

export function getVisitedPages() {

  return (
    JSON.parse(
      localStorage.getItem(STORAGE_KEY)
    ) || []
  );
}

// ======================================================
// CLEAR TRACKER
// ======================================================

export function clearVisitedPages() {

  localStorage.removeItem(STORAGE_KEY);
}